import { render, staticRenderFns } from "./commentsList.vue.html?vue&type=template&id=3ac94b89&"
import script from "./commentsList.ts?vue&type=script&lang=ts&"
export * from "./commentsList.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports